module.exports = __webpack_public_path__ + "static/media/avatar_default_circle.57ffe1aa.svg";